<template>
  <t-form labelWidth="80px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <CptDefault :attribute="attribute" :currentCpt="currentCpt" />
    <!-- <t-form-item label="默认选项URL">
      <t-input size="small" v-model="attribute.defaultUrlValue" placeholder="请输入"/>
    </t-form-item>
     <t-form-item label="默认选项">
      <t-select size="small" :options="options" v-model="attribute.defaultValue" placeholder="请选择" clearable filterable />
    </t-form-item> -->
    <CptRadioOptionBase :attribute="attribute" :currentCpt="currentCpt" @changeSize="changeSize" @changeLayout="changeLayout"/>
  </t-form>
</template>

<script>
import CptData from "@/components/element/options/comp/cpt-data";
import CptDefault from '@/components/element/options/comp/cpt-default'
import CptRadioOptionBase from "@/components/element/options/comp/cpt-radio-option-base";
export default {
  name: "cpt-radio-option",
  components: { CptData,CptDefault,CptRadioOptionBase },
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
  },
  data() {
    return {
      sizeOptions: {
        small: { width: 16, height: 16, borderRadus: 16,buttonWidth:60,buttonHeight:20 },
        medium: { width: 20, height: 20, borderRadus: 20,buttonWidth:80,buttonHeight:25  },
        large: { width: 24, height: 24, borderRadus: 24,buttonWidth:100,buttonHeight:30  },
      },
      layoutOptions: {
        row: { buttonLeft: 5, buttonTop: 0},
        column: { buttonLeft: 0, buttonTop: 5},
      },
    };
  },
  methods: {
    changeSize(val) {
      const sizeAttributes = this.sizeOptions[val];
      if (sizeAttributes) {
        this.attribute.width = sizeAttributes.width;
        this.attribute.height = sizeAttributes.height;
        this.attribute.borderRadus = sizeAttributes.borderRadus;
      } else {
        console.warn(`Invalid size option: ${val}`);
      }
    },
    changeLayout(val) {
      const layoutAttributes = this.layoutOptions[val];
      if (layoutAttributes) {
        this.attribute.buttonTop = layoutAttributes.buttonTop;
        this.attribute.buttonLeft = layoutAttributes.buttonLeft;
      } else {
        console.warn(`Invalid size option: ${val}`);
      }
    }
  },
};
</script>

<style>
</style>